import { action, computed, observable, reaction, runInAction } from 'mobx';
import { toast } from 'react-toastify';

import agent from '../api/agent';
import { formatParameterDisp2 } from '../common/util/util';
import { IFrameFilters, ISchedule } from '../models/frame';
import { IOption } from '../models/option';
import { RootStore } from './rootStore';

export default class FrameStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    reaction(
      () => this.frameFilters,
      () => {
        this.scheduleRegistry.clear();
        this.loadFrames();
      }
    );
  }

  @observable scheduleRegistry = new Map();
  @observable
  frameFilters: IFrameFilters | null = null;
  @observable scheduleOptions: IOption[] = [];

  @observable loading = false;
  @observable submitting = false;

  @computed get schedules() {
    return Array.from(this.scheduleRegistry.values());
  }

  @action setFrameFilters = (frameFilters: IFrameFilters) => {
    this.frameFilters = frameFilters;
  };

  @action loadFrames = async () => {
    this.loading = true;
    try {
      const frames = await agent.Reservations.listForAdmin(
        formatParameterDisp2(this.frameFilters?.reservationDate!)
      );
      runInAction('loading frames', () => {
        frames.schedules.forEach((s) => {
          this.scheduleRegistry.set(s.schedule, s);
        });
        this.scheduleOptions = frames.schedules
          .filter((s) => s.remains > 0)
          .map((s) => ({
            key: s.schedule,
            value: s.schedule,
            text: s.schedule,
          }));
        this.loading = false;
      });
    } catch (error) {
      runInAction('load frames error', () => {
        this.loading = false;
      });
    }
  };

  @action createFrame = async (schedule: ISchedule) => {
    this.submitting = true;
    try {
      await agent.Reservations.createFrame(schedule);
      runInAction('creating frame', () => {
        this.submitting = false;
      });
      this.scheduleRegistry.clear();
      this.loadFrames();
    } catch (error) {
      runInAction('create frame error', () => {
        this.submitting = false;
      });
      toast.error('登録処理でエラーが発生しました');
      console.log(error);
    }
  };
}
